module.exports = __webpack_public_path__ + "static/media/icona_info.bd1887c9.svg";